import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { detectMob, getDeviceType, parseURLParams, timeSince } from "../helper";
import FormModal from "./FormModal";
import Header from "./Header";
import Message from "./Message";
import NativeShare from "./NativeShare";
import $ from "jquery";
import Share from "./Share";
import ShareNow from "./ShareNow";

export default function HomePage() {
  const [suggestionCards, setSuggestionCards] = useState([]);
  const [userid, setUserid] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [share, setshare] = useState(false);
  const [displayMessage, setDisplayMessage] = useState("");
  const [suggestion, setSuggestion] = useState("");
  const [sugError, setsugError] = useState(false);
  const [canLoadMore, setCanLoadMore] = useState(false);
  const [listIndex, setListIndex] = useState(0);
  const [userPosted, setUserPosted] = useState(false);
  const [isReported, setIsReported] = useState(false);
  const [submittedUserDetails, setSubmittedUserDetails] = useState({
    whoYouAre: "",
    name: "",
    email: "",
    phone: "",
    state: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [showShareNow, setShowShareNow] = useState(false);

  const listInnerRef = useRef();

  //   const [userId, setUserId] = useState("");
  let loading = false;
  const changeSuggestionInputValue = (val) => {
    setSuggestion(val);
  };

  const showShareNowPortal = () => {
    setShowShareNow(true);
    // document.getElementById("sharenow").classList.add("show", "d-block");
    // document
    //   .querySelectorAll(".modal-backdrop")
    //   .forEach((el) => el.classList.add("modal-backdrop"));
  };

  const setUserPostedValue = (val) => {
    setUserPosted(val);
  };

  const addUserDetails = (details) => {
    setSubmittedUserDetails({ ...submittedUserDetails, ...details });
  };

  const submitSuggestion = () => {
    if (!suggestion || suggestion.length == 0) {
      setsugError(true);
      return false;
    } else {
      setsugError(false);
    }

    setIsLoading(true);
    var formdata = new FormData();
    formdata.append("action", "postsuggestion");
    formdata.append("token", "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga");
    formdata.append("userid", userid ? userid : "");
    formdata.append("user_name", submittedUserDetails["name"]);
    formdata.append("user_email", submittedUserDetails["email"]);
    formdata.append("user_phone", submittedUserDetails["phone"]);
    formdata.append(
      "user_avatar",
      submittedUserDetails["avatar"] ? submittedUserDetails["avatar"] : ""
    );
    formdata.append("user_state", submittedUserDetails["state"]);
    formdata.append("who_you_are", submittedUserDetails["whoYouAre"]);
    formdata.append("user_suggestion", suggestion);
    // formdata.append(
    //   "user_avatar",
    //   "https://cdn.narendramodi.in/cmsuploads/0.16750300_1551771109_1551771256313.jpg"
    // );

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // !userid &&
        //   setUserDetails({
        //     whoYouAre: "",
        //     name: "",
        //     email: "",
        //     phone: "",
        //     state: "",
        //   });
        changeSuggestionInputValue("");
        if (result && result._resultflag == 1) {
          setUserPostedValue(true);
        } else {
          setUserPostedValue(false);
        }

        document
          .getElementById("exampleModalCenter")
          .classList.remove("show", "d-block");
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.classList.remove("modal-backdrop"));
        setTimeout(() => {
          hideModal();
        }, 200);
        var link = document.getElementById("sharenowbutton");
        link.click();
        setTimeout(() => {
          getSuggestionList(userid);
        }, 300);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  const getSuggestionList = (userid) => {
    setIsLoading(true);
    var formdata = new FormData();
    formdata.append("action", "suggestionlist");
    formdata.append("token", "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga");
    formdata.append("userid", userid);

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setIsLoading(false);
        if (
          result &&
          (result._resultflag === 1 || result._resultflag === "1")
        ) {
          let index = listIndex + 1;
          setListIndex(index);
          result.data.length >= 10
            ? setCanLoadMore(true)
            : setCanLoadMore(false);
          setSuggestionCards(result.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  const loadMore = () => {
    setIsLoading(true);
    var formdata = new FormData();
    formdata.append("action", "suggestionlist");
    formdata.append("token", "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga");
    formdata.append("userid", userid);
    formdata.append("index", listIndex);

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          (result._resultflag === 1 || result._resultflag === "1")
        ) {
          let index = listIndex + 1;
          setListIndex(index);
          result.data.length >= 10
            ? setCanLoadMore(true)
            : setCanLoadMore(false);
          let data = [...suggestionCards, ...result.data];
          //   console.log("data is ", data);
          setSuggestionCards(data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoading(false);
      });
  };

  const setLikeUnlike = (postid, userid, likeunlike) => {
    setIsLoading(true);
    loading = true;
    var formdata = new FormData();
    formdata.append("action", "suggestionlikedislike");
    formdata.append("token", "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga");
    formdata.append("userid", userid);
    formdata.append("postid", postid);
    formdata.append("flag", likeunlike.toString());

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        try {
          let obj = {
            platform: getDeviceType(),
          };
          window.gtag("event", "suggestion_like", obj);
        } catch (error) {}
        getSuggestionList(userid);
        loading = false;
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        loading = false;
        setIsLoading(false);
      });
  };

  const showMessagePopup = (msg) => {
    setDisplayMessage(msg);
    setShowMessage(true);
  };

  const reportPost = (postid, userid) => {
    setIsLoading(true);
    loading = true;
    var formdata = new FormData();
    formdata.append("action", "reportsuggestion");
    formdata.append("token", "T0gtBtYh1hACFYAXQg8NS1eCe5W4KAga");
    formdata.append("userid", userid);
    formdata.append("postid", postid);

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result && result._resultflag == 1) {
          //   alert(result.message);
          try {
            let obj = {
              platform: getDeviceType(),
            };
            window.gtag("event", "report_suggestion", obj);
          } catch (error) {}
          showMessagePopup(result.message);
        } else {
          if (result.message == "Missing Parameter") {
            showMessagePopup("You need to login to report this post");
          }
        }
        getSuggestionList(userid);
        loading = false;
        setIsLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        loading = false;
        setIsLoading(false);
      });
  };

  useEffect(() => {
    let href = window.location.href.split("?");
    // console.log("href", href.length);
    if (href.length > 2) {
      href = "?" + href[2];
    } else {
      href = window.location.href;
    }
    let par = href.indexOf("userid") != -1 ? parseURLParams(href) : "";

    let userid = par["userid"] ? par["userid"][0] : "";
    setUserid(userid);
    getSuggestionList(userid);
  }, []);

  const hideMsgPopup = () => {
    setShowMessage(false);
  };

  const getShare = () => {
    setshare(true);
  };

  const hideModal = () => {
    setShowModal(false);
  };

  console.log("sharenow", showShareNow);
  return (
    <div>
      {/* <Header /> */}
      {/* loader */}
      <button
        type="button"
        id="sharenowbutton"
        className="btn btn-primary"
        data-toggle="modal"
        data-target="#sharenow"
        style={{ display: "none" }}
      >
        Launch demo modal
      </button>
      <ShareNow />
      {isLoading && (
        <div className="loader_overlay">
          <div className="bt-spinner"></div>
          <h5>Loading...</h5>
        </div>
      )}
      {/* loader */}
      <div className="container">
        <div className="pariksha_logo">
          {/* {window.location.href.indexOf("appversion") != -1 && (
            <img src="/images/Logo-01.png" />
          )} */}
        </div>
        <div className="pariksha_homeBaner">
          <img
            src="/images/banner_ppc.jpg"
            alt="Pariksha Pe Charcha with PM Modi Banner"
          />
          <h6>
            "I am an Exam Warrior because..."
            <br />
            <br />
            PM Modi wants to hear your unique exam mantras!
            <br />
            <br />
            As an exam warrior in shining armor, what helps you conquer the fear
            of exams and power through? Share your PoV, your study rituals, your
            prep-finds or anything that is your mantra for success during exams
            in 300 words.
            <br />
            <br />
            Top 10 Exam Warriors with the best exam mantras win a
            once-in-a-lifetime opportunity to visit the PM's residence!
          </h6>
        </div>
        <div className="input_wrp">
          <textarea
            maxLength="1000"
            className="par_input"
            value={suggestion}
            onChange={(e) => {
              setSuggestion(e.target.value);
              e.target.value && setsugError(false);
            }}
            placeholder="Please enter your suggestions"
          ></textarea>
          <div className="btnpost">
            <button
              className="parik_btn"
              data-toggle="modal"
              data-target={suggestion && !userPosted && "#exampleModalCenter"}
              onClick={() => {
                userPosted && submitSuggestion();
                !suggestion ? setsugError(true) : setsugError(false);
                setShowModal(true);
              }}
            >
              <img src="/images/chevron-right.png" />
            </button>
          </div>
        </div>
        {sugError && (
          <small id="emailHelp" className="form-text text_error">
            Please enter your suggestion to proceed
          </small>
        )}
        <div className="banner_ec">
          {window.location.href.indexOf("appversion") != -1 ? (
            <a
              href="https://www.narendramodi.in/examwarriors?ignore.zip"
              // target={"_blank"}
            >
              <img
                src={
                  detectMob() == "mobile"
                    ? "/images/exammobile.jpg"
                    : "/images/examdesktop.jpg"
                }
              />
            </a>
          ) : (
            <a href="https://www.narendramodi.in/examwarriors" target="_blank">
              <img
                src={
                  detectMob() == "mobile"
                    ? "/images/exammobile.jpg"
                    : "/images/examdesktop.jpg"
                }
              />
            </a>
          )}
        </div>

        {/* <div className="banner_ec">
          <img
            src={
              detectMob() == "mobile"
                ? "/images/exammobile.jpg"
                : "/images/examdesktop.jpg"
            }
          />
        </div> */}
        <div className="cards_section">
          {suggestionCards &&
            suggestionCards.length > 0 &&
            suggestionCards.map((card) => {
              return (
                <section className="pariksha_cards" key={card.id}>
                  <div className="parik_cards_name">
                    <img
                      src={
                        card.user_avatar
                          ? card.user_avatar
                          : "/images/profile.png"
                      }
                    />
                    <div className="parik_cards_txt">
                      <h4>{card.user_name}</h4>
                      <h6>{timeSince(moment(card.updated_on))}</h6>
                    </div>
                  </div>
                  <p className="parik_cards_txt_p">{card.user_suggestion}</p>
                  <div className="pariksha_like_row">
                    <div className="pariksha_like_left">
                      <span
                        onClick={() =>
                          userid
                            ? !loading &&
                              setLikeUnlike(
                                card.id,
                                userid,
                                card.isLiked == 1 ? "2" : "1"
                              )
                            : window.location.href.indexOf("appversion") != -1
                            ? (window.location.href = "appclick://login")
                            : showMessagePopup(
                                "Please login to like or report."
                              )
                        }
                      >
                        <img
                          src={
                            card.isLiked == 1
                              ? "/images/liked.svg"
                              : "/images/like.svg"
                          }
                        />
                        {card.likecount}
                      </span>

                      <NativeShare getShare={getShare} />
                    </div>
                    <img
                      onClick={() =>
                        userid
                          ? !loading && reportPost(card.id, userid)
                          : window.location.href.indexOf("appversion") != -1
                          ? (window.location.href = "appclick://login")
                          : showMessagePopup("Please login to like or report.")
                      }
                      src={
                        card.isReported == 1
                          ? "/images/reported.png"
                          : "/images/flag.png"
                      }
                    />
                  </div>
                </section>
              );
            })}
          {canLoadMore && (
            <div className="text-center mt-5">
              <button
                onClick={() => canLoadMore && loadMore()}
                className="btn btn-primary"
              >
                Load More
              </button>
            </div>
          )}

          {/* <section className="pariksha_cards">
            <div className="parik_cards_name">
              <img src="/images/profile.png" />
              <div className="parik_cards_txt">
                <h4>Hemant bhai patel</h4>
                <h6>2 mins ago</h6>
              </div>
            </div>
            <p className="parik_cards_txt_p">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
            <div className="pariksha_like_row">
              <div className="pariksha_like_left">
                <span>
                  <img src="/images/like.png" />
                  20
                </span>
                <span>
                  <img src="/images/reply.png" />
                  Reply
                </span>
                <span>
                  <img src="/images/share.png" />
                  Share
                </span>
              </div>
              <img src="/images/flag.png" />
            </div>
          </section> */}
        </div>
      </div>

      {/* {userid && ( */}

      {share && <Share />}
      {showModal && (
        <FormModal
          userid={userid}
          suggestion={suggestion}
          getSuggestionList={getSuggestionList}
          hideModal={hideModal}
          changeSuggestionInputValue={changeSuggestionInputValue}
          setUserPostedValue={setUserPostedValue}
          addUserDetails={addUserDetails}
          showShareNowPortal={showShareNowPortal}
        />
      )}
      {/* )} */}
      {showMessage && (
        <Message message={displayMessage} hideMsgPopup={hideMsgPopup} />
      )}
    </div>
  );
}
